"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Trash = _interopRequireDefault(require("@rsuite/icon-font/lib/action/Trash"));

// Generated by script, don't edit it please.
var Trash = (0, _createSvgIcon["default"])({
  as: _Trash["default"],
  ariaLabel: 'trash',
  category: 'action',
  displayName: 'Trash'
});
var _default = Trash;
exports["default"] = _default;
module.exports = exports.default;